// extracted by mini-css-extract-plugin
export default {"links":"Links_links__1ahHo","linksRow":"Links_linksRow__NOO3M"};